import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const RootClassController = () => {
  const location = useLocation();

  useEffect(() => {
    const root = document.getElementById("react-root");
    if (!root) return;

    const pageClasses = [
      "home",
      "mydata",
      "help",
      "login",
      "sign_up",
      "sign_up_done",
      "sign_up_pass",
      "sign_up_user",
      "sign_up_completed",
      "first_auth",
      "first_auth_completed",
      "update_id_completed",
      "reset_pass",
      "reset_pass_done",
      "reset_pass_set",
      "reset_pass_completed",
      "single",
      "error",
    ];

    pageClasses.forEach(cls => root.classList.remove(cls));

    let pageClass: string;

    switch (location.pathname) {
      case "/":
      case "/login":
      case "/sign_up":
      case "/sign_up_done":
      case "/sign_up_pass":
      case "/sign_up_user":
      case "/sign_up_completed":
      case "/first_auth":
      case "/first_auth_completed":
      case "/update_id_completed":
      case "/reset_pass":
      case "/reset_pass_done":
      case "/reset_pass_set":
      case "/reset_pass_completed":
        pageClass = "single";
        break;

      case "/home":
        pageClass = "home";
        break;
 
      case "/mydata":
        pageClass = "mydata";
        break;
      
      case "/error":
        pageClass = "error";
        break;

      default:
        pageClass = "error";
    }

    if (pageClass) {
      root.classList.add(pageClass);
    }
  }, [location.pathname]);

  return null; // DOMは描画しない
};